import _ from 'underscore'
import Vue from 'vue'
import UserActivityExport from '../../resources/userActivityExport'
import UserActivityReport from '../../resources/userActivityReport'

// This is an object where ads will be stored
// with keys as the id, and ad as the value
const state = {
  
}

const getters = {
  
}

const actions = {
  getUserActivityExport(context, payload) {
    if (payload.model) {
      UserActivityExport.save(payload.model).then((res) => {
        if (_.isFunction(payload.callback)) payload.callback(res.body);
      }, (res) => {
        Toast.error('Failed to export user activity')
        if (_.isFunction(payload.failedCallback)) payload.failedCallback(res.body);
      })
    } else {
      Toast.error('No parameters specified')
      if (_.isFunction(payload.failedCallback)) payload.failedCallback(res.body);
    }
  },

  getUserActivityReport(context, payload) {
    if (payload.model) {
      UserActivityReport.save(payload.model).then((res) => {
        if (_.isFunction(payload.callback)) payload.callback(res.body);
      }, (res) => {
        Toast.error('Failed to export user activity')
        if (_.isFunction(payload.failedCallback)) payload.failedCallback(res.body);
      })
    } else {
      Toast.error('No parameters specified')
      if (_.isFunction(payload.failedCallback)) payload.failedCallback(res.body);
    }
  },
}

const mutations = {
  

}



export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user-activity-report.js